import './FullScreenLoader.scss';

const FullScreenLoader = () => {
  return (
    <div className='fullscreen-loader'>
      <div className='loader-card'>
        <div className='spinner'>
          <div className='spinner-ring' />
          <div className='spinner-dot' />
        </div>
      </div>
    </div>
  );
};

export default FullScreenLoader;